import { useResponsiveProp } from "@shopify/restyle";

/**
 * Booking summary column, header, and footer pin to this width once the
 * viewport is large enough. Below it, they stretch to 100%.
 */
export const BOOKING_SUMMARY_CONTENT_MAX_WIDTH = 544;

/**
 * True when the summary should go full-bleed instead of pinning at
 * BOOKING_SUMMARY_CONTENT_MAX_WIDTH.
 */
export const useIsBookingSummaryNarrow = (): boolean =>
  Boolean(useResponsiveProp({ base: 1, 544: 0 }));

/**
 * True when charges/confirm stay stacked in the main column. False when the
 * side payment panel can sit beside the 544px column (needs ~544 + 368).
 */
export const useIsBookingSummaryStacked = (): boolean =>
  Boolean(useResponsiveProp({ base: 1, 995: 0 }));
